import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import AgentModel from "../../models/party/agent-model";
import GenderModel from "../../models/masters/gender-model";

const url = getEndPoint(API_END_POINT.PARTY) +"/api/Agent/GetAllAgent";// //{/api/Agent/GetAllAgent}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetAgent = createQuery<
AgentModel[],
  null,
  AxiosError
>({
  queryKey: ["keyAgentpage"],
  fetcher: (params) => 
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),

    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});


const genderurl = getEndPoint(API_END_POINT.MASTER) +"/api/Gender/GetAllGender";// //{/api/Agent/GetAllAgent}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetGenders= createQuery<
GenderModel[],
  null,
  AxiosError
>({
  queryKey: ["keyGenderpage"],
  fetcher: (params) =>
        getDataWithToken<any>(genderurl).then((response) => response.data?.result || console.log(response)),
    
    // axios.get(genderurl, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});